<mat-menu xPosition="before" (menuOpened)="opened()">
  <div class="menu-title">{{ 'Settings' | translate }}</div>
  <button mat-menu-item (click)="goToDevices()">
    <mat-icon>videocam</mat-icon>
    <span>{{ 'Devices' | translate }}</span>
    @if (alertBadge$ | async; as alertCount) {
      <span class="count-badge">{{ alertCount }}</span>
    }
  </button>
  @if (isExecutive$ | async) {
    <button mat-menu-item (click)="goToUsers()">
      @if (missingAlertRecipient$ | async) {
        <span class="attention-dot" [matTooltip]="'No alert recipients set' | translate"></span>
      }
      <mat-icon>group</mat-icon>
      <span>{{ 'Users' | translate }}</span>
    </button>
  }
  @if (showInstall$ | async) {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="installPwa()">
      <mat-icon>download</mat-icon>
      <span>{{ 'Install App' | translate }}</span>
    </button>
  }
</mat-menu>
